   import React, { useContext } from 'react';
   import { DataContext } from './context/DataContext';

   function Footer() {
      const ProductData = useContext(DataContext);
      const { ProductName, PhoneNumber, Email, Menu1, Menu2, Menu3, Menu4, Menu5, FooterMenu5 } = ProductData;

      return (
         <div className="col-12 flex flex-wrap bg-primary py-2 text-white text-center mt-auto">
            <div className="hidden flex-wrap col-12 md:col-6 justify-content-center align-items-center p-gap-4 lg:py-1 lg:flex ">
               <img src="./website/cs-small.png" alt="CS Logo" height="40" />
               <span className="font-bold text-xl">CHINMMAI SYSTEMSS</span>
            </div>
            <div className="col-12 md:col-6 text-sm">
               Copyright &copy; {new Date().getFullYear()}, Chinmmai Systemss Private Limited. All Rights Reserved.
            </div>
         </div>
      )
   }

   export default Footer;
